import { createAction, props } from '@ngrx/store';
import {
  SubmittalRegistryPayloadDto,
  SubmittalPackageCreateUpdateReq,
  SubmittalPackageListingItem,
  SubmittalPackageFilterParams,
  SubmittalRegistry,
  SubmittalRegistryFilterParams,
  SubmittalPackageResp,
  SubmittalRegistryPartialUpdateDto,
  SUBMITTAL_PACKAGE_STATUS,
} from './submittals.types';

// Create Submittal Registry Entry
const createSubmittalRegistry = createAction(
  '[Submittals] Create Submittal Registry Entry',
  props<{ registry: SubmittalRegistryPayloadDto }>(),
);

const createSubmittalRegistrySuccess = createAction(
  '[Submittals] Create Submittal Registry Entry Success',
  props<{ registry: SubmittalRegistry }>(),
);

const createSubmittalRegistryFailure = createAction(
  '[Submittals] Create Submittal Registry Entry Failure',
  props<{ error: string }>(),
);

const loadNextRegistryIdSuccess = createAction(
  '[Submittals] Load Next Registry Entry Id Success',
  props<{ nextRegistryId: string }>(),
);

const loadNextRegistryIdFailure = createAction(
  '[Submittals] Load Next Registry Entry Id Failure',
  props<{ error: string }>(),
);
const loadSubmittalRegistryItems = createAction(
  '[Submittals] Load Submittal Registry Items',
  props<{ projectId: number; filters: SubmittalRegistryFilterParams }>(),
);

const loadSubmittalRegistriesSuccess = createAction(
  '[Submittals] Load Submittal Registries Success',
  props<{ registries: SubmittalRegistry[]; filters: SubmittalRegistryFilterParams }>(),
);

const loadSubmittalRegistriesFailure = createAction(
  '[Submittals] Load Submittal Registries Failure',
  props<{ error: string }>(),
);

const createRevisionForRegistryItemsFailure = createAction(
  '[Submittals] Create Revision For Registry Items Failure',
);
const createRevisionForRegistryItemsSuccess = createAction(
  '[Submittals] Create Revision For Registry Items Success',
);
const deleteSubmittalRegistryItemSuccess = createAction(
  '[Submittals] Delete Submittal Registry Item Success',
);
const deleteSubmittalRegistryItemFailure = createAction(
  '[Submittals] Delete Submittal Registry Item Failure',
);
const bulkAssignRegistryOwnerSuccess = createAction(
  '[Submittals] Bulk assign registry owner Success',
);
const bulkAssignRegistryOwnerFailure = createAction(
  '[Submittals] Bulk assign registry owner Failure',
);

// ---------------------------
// Submittal Package Log
// ---------------------------

// Create Submittal Package
const createSubmittalPackage = createAction(
  '[Submittals] Create Submittal Package',
  props<{ submittalPackage: SubmittalPackageCreateUpdateReq }>(),
);

const createSubmittalPackageSuccess = createAction(
  '[Submittals] Create Submittal Package Success',
  props<{ submittalPackage: SubmittalPackageResp }>(),
);

const createSubmittalPackageFailure = createAction(
  '[Submittals] Create Submittal Package Failure',
  props<{ error: string }>(),
);

// Update Submittal Package
const updateSubmittalPackage = createAction(
  '[Submittals] Update Submittal Package',
  props<{ submittalPackage: SubmittalPackageCreateUpdateReq }>(),
);

const updateSubmittalPackageSuccess = createAction(
  '[Submittals] Update Submittal Package Success',
  props<{ submittalPackage: SubmittalPackageResp }>(),
);

const updateSubmittalPackageFailure = createAction(
  '[Submittals] Update Submittal Package Failure',
  props<{ error: string }>(),
);

// ---------------------------
// Submittal Log
// ---------------------------

const submittalPackageListOpened = createAction(
  '[Submittals] Submittal Package List Opened',
  props<{ projectId: number }>(),
);

const loadPackageListSuccess = createAction(
  '[Submittals] Load Submittal Packages List Success',
  props<{ packages: SubmittalPackageListingItem[]; filters: SubmittalPackageFilterParams }>(),
);

const loadPackageListFailure = createAction(
  '[Submittals] Load Submittal Packages List Failure',
  props<{ error: string }>(),
);

const packageListFiltersChanged = createAction(
  '[Submittals] Submittal Packages List Filters Changed',
  props<{ projectId: number; filters: Partial<SubmittalPackageFilterParams> }>(),
);

const loadNextPackagePage = createAction(
  '[Submittals] Load Next Submittal Packages Page',
  props<{ projectId: number }>(),
);

const loadPackageDetails = createAction(
  '[Submittals] Load Submittal Package Details',
  props<{ packageId: number }>(),
);

const loadPackageDetailsSuccess = createAction(
  '[Submittals] Load Submittal Package Details Success',
  props<{ packageDetails: SubmittalPackageResp }>(),
);

const loadPackageDetailsFailure = createAction(
  '[Submittals] Load Submittal Package Details Failure',
);

const updateSubmittalPackageStatus = createAction(
  '[Submittals] Update Submittal Package Patch',
  props<{ packageId: number; status: SUBMITTAL_PACKAGE_STATUS }>(),
);
const updateSubmittalPackageStatusSuccess = createAction(
  '[Submittals] Update Submittal Package Patch Success',
  props<{ submittalPackage: SubmittalPackageResp }>(),
);
const updateSubmittalPackageStatusFailure = createAction(
  '[Submittals] Update Submittal Package Patch Failure',
);

const updatePackageRegistryEntry = createAction(
  '[Submittals] Update Package Registry Entry',
  props<{ registryEntryId: number; registryEntryPayload: SubmittalRegistryPartialUpdateDto }>(),
);
const updatePackageRegistryEntrySuccess = createAction(
  '[Submittals] Update Package Registry Entry Success',
  props<{ registryEntry: SubmittalRegistry }>(),
);
const updatePackageRegistryEntryFailure = createAction(
  '[Submittals] Update Package Registry Entry Failure',
  props<{ registryEntryId: number }>(),
);

const packageFileDeleteSuccess = createAction(
  '[Submittals] Package File Delete Success',
  props<{ packageId: number; fileId: number }>(),
);
const packageFileDeleteFailure = createAction(
  '[Submittals] Package File Delete Failure',
  props<{ packageId: number; fileId: number }>(),
);

const packageFileCategoryDeleteSuccess = createAction(
  '[Submittals] Package File Category Delete Success',
  props<{ packageId: number }>(),
);
const packageFileCategoryDeleteFailure = createAction(
  '[Submittals] Package File Category Delete Failure',
  props<{ packageId: number }>(),
);

const sendPackageForApprovalSuccess = createAction(
  '[Submittals] Send Package For Approval Success',
  props<{ packageId: number }>(),
);
const sendPackageForApprovalFailure = createAction(
  '[Submittals] Send Package For Approval Failure',
  props<{ packageId: number }>(),
);

const submitPackageToOwnerSuccess = createAction(
  '[Submittals] Submit Package To Owner Success',
  props<{ submittalPackage: SubmittalPackageResp }>(),
);
const submitPackageToOwnerFailure = createAction(
  '[Submittals] Submit Package To Owner Failure',
  props<{ packageId: number }>(),
);
const cancelSubmitPackageToOwnerSuccess = createAction(
  '[Submittals] Cancel Submit Package To Owner Success',
  props<{ submittalPackage: SubmittalPackageResp }>(),
);
const cancelSubmitPackageToOwnerFailure = createAction(
  '[Submittals] Cancel Submit Package To Owner Failure',
  props<{ packageId: number }>(),
);

const createRevisionForPackageSuccess = createAction(
  '[Submittals] Create Package Revision Success',
  props<{ packageId: number }>(),
);
const createRevisionForPackageFailure = createAction(
  '[Submittals] Create Package Revision Failure',
  props<{ packageId: number }>(),
);

const voidPackageSuccess = createAction(
  '[Submittals] Void Package Success',
  props<{ packageId: number }>(),
);
const voidPackageFailure = createAction(
  '[Submittals] Void Package Failure',
  props<{ packageId: number }>(),
);

const deletePackageSuccess = createAction(
  '[Submittals] Delete Package Success',
  props<{ packageId: number }>(),
);
const deletePackageFailure = createAction(
  '[Submittals] Delete Package Failure',
  props<{ packageId: number }>(),
);

const closePackageSuccess = createAction(
  '[Submittals] Close Package Success',
  props<{ packageId: number }>(),
);
const closePackageFailure = createAction(
  '[Submittals] Close Package Failure',
  props<{ packageId: number }>(),
);

const reopenPackageSuccess = createAction(
  '[Submittals] Reopen Package Success',
  props<{ packageId: number }>(),
);
const reopenPackageFailure = createAction(
  '[Submittals] Reopen Package Failure',
  props<{ packageId: number }>(),
);

// Common actions
const cancel = createAction('[Submittals] Cancel');

export const submittalsActions = {
  // Registry items actions
  loadSubmittalRegistryItems,
  loadSubmittalRegistriesSuccess,
  loadSubmittalRegistriesFailure,

  createRevisionForRegistryItemsFailure,
  createRevisionForRegistryItemsSuccess,

  deleteSubmittalRegistryItemSuccess,
  deleteSubmittalRegistryItemFailure,

  bulkAssignRegistryOwnerSuccess,
  bulkAssignRegistryOwnerFailure,

  // Package actions
  submittalPackageListOpened,
  loadPackageListSuccess,
  loadPackageListFailure,
  packageListFiltersChanged,
  loadNextPackagePage,

  createSubmittalRegistry,
  createSubmittalRegistrySuccess,
  createSubmittalRegistryFailure,

  createSubmittalPackage,
  createSubmittalPackageSuccess,
  createSubmittalPackageFailure,

  updateSubmittalPackage,
  updateSubmittalPackageSuccess,
  updateSubmittalPackageFailure,

  loadNextRegistryIdSuccess,
  loadNextRegistryIdFailure,

  // Package Details actions
  loadPackageDetails,
  loadPackageDetailsSuccess,
  loadPackageDetailsFailure,

  updateSubmittalPackageStatus,
  updateSubmittalPackageStatusSuccess,
  updateSubmittalPackageStatusFailure,

  updatePackageRegistryEntry,
  updatePackageRegistryEntrySuccess,
  updatePackageRegistryEntryFailure,

  packageFileDeleteSuccess,
  packageFileDeleteFailure,

  packageFileCategoryDeleteSuccess,
  packageFileCategoryDeleteFailure,

  sendPackageForApprovalSuccess,
  sendPackageForApprovalFailure,

  submitPackageToOwnerSuccess,
  submitPackageToOwnerFailure,

  cancelSubmitPackageToOwnerSuccess,
  cancelSubmitPackageToOwnerFailure,

  createRevisionForPackageSuccess,
  createRevisionForPackageFailure,

  voidPackageSuccess,
  voidPackageFailure,

  deletePackageSuccess,
  deletePackageFailure,

  closePackageSuccess,
  closePackageFailure,

  reopenPackageSuccess,
  reopenPackageFailure,

  // Common
  cancel,
};
